const openInNewTab = (url) => {
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.download = 'true'
  if (typeof link.download === 'undefined') {
    link.setAttribute('target', '_blank')
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
export default openInNewTab
